import { useRequest } from '@byted/hooks';
import { Toast } from '@douyinfe/semi-ui';
import { forumPostService } from '@/api/forumPost';
import { Biz } from '@/typings/open.platform.forum_bff/namespaces/configure';

const toggleTopFetcher = async (id: string, biz: Biz) => {
  const res = await forumPostService.toggleTop({
    PostId: id,
    Uid: '',
    Biz: biz,
  });
  if (res.error) {
    throw new Error(res.message);
  }
  return res.data;
};
const toggleGoodFetcher = async (id: string, biz: Biz) => {
  const res = await forumPostService.toggleGood({
    PostId: id,
    Uid: '',
    Biz: biz,
  });
  if (res.error) {
    throw new Error(res.message);
  }
  return res.data;
};
export const useTopAndGood = () => {
  const { run: toggleTop } = useRequest(toggleTopFetcher, {
    auto: false,
    onSuccess() {
      Toast.success('操作成功');
    },
    onError() {
      Toast.error('操作失败，请联系社区研发');
    },
  });
  const { run: toggleGood } = useRequest(toggleGoodFetcher, {
    auto: false,
    onSuccess() {
      Toast.success('操作成功');
    },
    onError() {
      Toast.error('操作失败，请联系社区研发');
    },
  });

  return {
    toggleTop,
    toggleGood,
  };
};
